
import { Vue, Component } from 'vue-property-decorator';
import { apiMessages } from '../../api/message-api';
import { Regions } from '../../types/error';
import { apiFetchErrorRegions } from '../../api/regions';

@Component
export default class NotFoundPage extends Vue {
  private messages: any = {};
  private regions = [] as Regions;
  private show = false;

  created() {
    document.addEventListener('click', this.regionBlurClick);
  }

  regionBlurClick(e: Event) {
    const dropDownButton = document.querySelector('.platmap-error__btn');
    const dropDownMenu = document.querySelector('.dropdown-menu');
    if (
      dropDownMenu &&
      !dropDownMenu.contains(e.target as Node) &&
      dropDownButton &&
      !dropDownButton.contains(e.target as Node)
    ) {
      this.show = false;
    }
  }

  beforeDestroy() {
    document.removeEventListener('click', this.regionBlurClick);
  }

  constructor() {
    super();
    this.loadMessages();
    this.loadRegions();
  }

  async loadMessages() {
    const { messages } = await apiMessages('404Page');
    this.messages = messages;
  }

  async loadRegions() {
    const { regions } = await apiFetchErrorRegions();
    this.regions = regions;
  }

  showListHandler() {
    this.show = !this.show;
  }
}
